import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=0631cd66&scoped=true&lang=pug&"
import script from "./Home.vue?vue&type=script&lang=js&"
export * from "./Home.vue?vue&type=script&lang=js&"
import style0 from "./Home.vue?vue&type=style&index=0&id=0631cd66&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0631cd66",
  null
  
)

/* custom blocks */
import block0 from "@/lang/views/home.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fvercel%2Fpath0%2Fsrc%2Fviews%2FHome.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports